export const getVideoLabel = (type, duration) => {
  switch (type) {
    case 'video':
      return duration
    case 'live':
      return 'živě'
  }
}
